/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { ContactDetailsBusinessService } from '../../resources/contact-details-business.service';
import { ContactDuplicatesDialogComponent } from './contact-duplicates-dialog.component';

export const contactDuplicatesDialog = createDialogRoute({
  component: ContactDuplicatesDialogComponent,
  init: {
    service: ContactDetailsBusinessService,
    selector: 'initDuplicatesDialogView',
  },
});
